import { Container, Grid, Paper, Typography, Button, Box, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import styles from './specificationsTab.module.css';
import { useNavigate } from 'react-router-dom';
import { formateDate } from '../../../../Website/utils/utils';
import { useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../../../Website/utils/api';
import { setReceiveEnquiryRefresh } from '../../../../Website/redux/recievedEnquiriesSlice';
import { useDispatch } from 'react-redux';

const StyledGrid = styled(Grid)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: theme.shape.borderRadius,
}));
const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    fontSize: '014px',
    color: '#667085',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    borderRadius: "4px",
    height: "40px",
    fontFamily: `'Public Sans', sans-serif`,
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));


const VenEnquiryDeets = ({ enquiryDetails }) => {
    const navigate = useNavigate()

    // Every part sent together in this enquiry (older enquiries have a single part and no items list)
    const items = enquiryDetails?.items || (enquiryDetails?._id ? [enquiryDetails] : [])
    const [quotes, setQuotes] = useState({})
    const dispatch = useDispatch()

    const setQuoteField = (id, field, value) => {
        setQuotes((prev) => ({ ...prev, [id]: { ...prev[id], [field]: value } }))
    }

    const handleSubmit = async () => {
        const filled = items
            .filter((item) => item?.status === "NEW" && quotes[item._id]?.quotePrice)
            .map((item) => ({ id: item._id, ...quotes[item._id] }))

        if (!filled.length) {
            return toast.error('quotePrice is required')
        }
        if (filled.some((q) => isNaN(q.quotePrice) || (q.moq && isNaN(q.moq)))) {
            return toast.error('enter valid quotePrice or moq')
        }
        if (filled.some((q) => q.datecode && isNaN(q.datecode))) {
            return toast.error('enter valid datecode and moq')
        }

        try {
            const response = await api.createBatchQuote({ id: enquiryDetails?._id, quotes: filled })
            if (response.data) {
                toast.success("Quoted successfully")
                setQuotes({})
                dispatch(setReceiveEnquiryRefresh())
            }
        } catch (err) {
            console.log(err);
            toast.error(err?.response?.data?.message || 'something went wrong')
        }

    }


    return (
        <div className={styles.profilebodyContainer}>
            <div className={styles.profileheader}>
                <Box display="flex" alignItems="center" >
                    <h2>Enquiry Details</h2>
                    <Typography style={{ margin: '6px' }}>•</Typography>
                    <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>
                        {enquiryDetails?._id}
                    </Typography>
                    <Typography style={{ margin: '6px' }}>•</Typography>
                    <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>

                        {formateDate(enquiryDetails?.createdAt)}
                    </Typography>
                    <Typography style={{ margin: '6px' }}>•</Typography>
                    <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: enquiryDetails?.status == "NEW" ? '#4A4C56' : enquiryDetails?.status == "QUOTED" ? "#F86624" : "#1A9882" }}>

                        {enquiryDetails?.status == "NEW" ? "Quote Pending" : enquiryDetails?.status == "QUOTED" ? "Quoted" : "Completed"}
                    </Typography>
                </Box>
                <button className={styles.editbtn} onClick={() => navigate(-1)}>Back to List</button>
            </div>
            <Paper sx={{ boxShadow: 'none', background: 'transparent', border: '1px solid #DCDEE3', borderRadius: "4px", margin: "16px" }}>
                <Box sx={{ padding: '10px 16px' }} display="flex" justifyContent="space-between" >
                    <Box display="flex" alignItems="center" gap='18px'>
                        <Box display="flex" alignItems="flex-start" flexDirection='column'>
                            <Typography style={{ padding: "6px 0px", borderRadius: '8px', fontSize: '14px', color: '#999999' }}>
                                Enquiry #
                            </Typography>
                            <Typography style={{ fontSize: '14px', fontWeight: "500", }}>
                                {enquiryDetails?._id}
                            </Typography>
                        </Box>
                        <Box display="flex" alignItems="center">
                            <svg width="2" height="40" viewBox="0 0 2 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 0L1 40" stroke="#E6E6E6" />
                            </svg>
                        </Box>
                        <Box display="flex" alignItems="flex-start" flexDirection='column'>
                            <Typography style={{ padding: "6px 0px", borderRadius: '8px', fontSize: '14px', color: '#999999' }}>
                                Status
                            </Typography>
                            <Typography style={{ fontSize: '14px', fontWeight: "500",color: enquiryDetails?.status == "NEW" ? '#4A4C56' : enquiryDetails?.status == "QUOTED" ? "#F86624" : "#1A9882" }}>
                                {enquiryDetails?.status}
                            </Typography>
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="center" >
                        {

                            enquiryDetails?.status === "NEW" ?
                                <ActionButton> Quote </ActionButton>
                                :
                                <button className={styles.submitBtn}>Quote details</button>
                        }
                    </Box>
                </Box>
            </Paper>

            <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "8px", marginTop: "26px", width: "100%" }}>
                <Box sx={{ p: 2, }} display="flex" justifyContent="space-between" >
                    <Box display="flex" alignItems="center" >
                        <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
                            PO
                        </Typography>
                        <Typography style={{ marginLeft: '10px', padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", background: "#EAFFFE", color: '#006C64' }}>
                            {items.length} Product{items.length !== 1 ? 's' : ''}
                        </Typography>
                    </Box>
                </Box>
              <div style={{width: "100%"}}>
              <table className={styles.previewtable}>
                    <thead>
                        <tr>
                            <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Sl No</th>
                            <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Manufacture Part #</th>
                            <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Required Quantity</th>
                            <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}> Manufacture</th>
                            <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Price </th>
                            <th className={styles.previewth}>MOQ</th>
                            {
                                enquiryDetails?.enquiryType === "EXCESS" && <>
                                                            <th className={styles.previewth}>Target Price</th>
                                                            <th className={styles.previewth}>Required Date</th>
                                </>
                            }
                            <th className={styles.previewth}>Date Code</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* {enquiryDetails?.partList?.map((item, index) => (
                        <tr className={styles.previewstripedRow}>
                            <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{index + 1}</td>
                            <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item?.productNumber}</td>
                            <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item?.quantity}</td>
                            <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item?.manufacturer}</td>
                            <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>
                                {enquiryDetails?.status == "NEW" ?
                                    <input type="text" placeholder="Enter qty" className={styles.dataInput} value={quotePrice} onChange={(e) => setQuotePrice(e.target.value)} />
                                    :
                                    <input type="text" placeholder="Enter qty" className={styles.dataInput} value={enquiryDetails?.partList?.quotePrice} disabled />
                                }
                            </td>
                            <td className={styles.previewtd}>
                                {enquiryDetails?.status == "NEW" ?
                                    <input type="text" placeholder="Enter" className={styles.dataInput} value={moq} onChange={(e) => setMoq(e.target.value)} />
                                    :
                                    <input type="text" placeholder="Enter qty" className={styles.dataInput} value={enquiryDetails?.partList?.moq} disabled />

                                }
                            </td>
                        </tr>
                      ))}  */}

                        
                        {items.map((item, index) => {
                            const isPending = item?.status == "NEW"
                            const quote = quotes[item?._id] || {}
                            return (
                                <tr className={styles.previewstripedRow} key={item?._id}>
                                    <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{index + 1}</td>
                                    <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item?.partList?.productNumber}</td>
                                    <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item?.partList?.quantity}</td>
                                    <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item?.partList?.manufacturer}</td>
                                    <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>
                                        {isPending ?
                                            <input type="text" placeholder="Enter Price" className={styles.dataInput} value={quote.quotePrice || ''} onChange={(e) => setQuoteField(item?._id, 'quotePrice', e.target.value)} />
                                            :
                                            <input type="text" placeholder="Enter Price" className={styles.dataInput} value={item?.partList?.quotePrice ?? ''} disabled />
                                        }
                                    </td>
                                    <td className={styles.previewtd}>
                                        {isPending ?
                                            <input type="text" placeholder="Enter MOQ" className={styles.dataInput} value={quote.moq || ''} onChange={(e) => setQuoteField(item?._id, 'moq', e.target.value)} />
                                            :
                                            <input type="text" placeholder="Enter MOQ" className={styles.dataInput} value={item?.partList?.moq ?? ''} disabled />
                                        }
                                    </td>
                                    {
                                        enquiryDetails?.enquiryType === "EXCESS" && <>
                                            <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item?.partList?.targetPrice || "NA"}</td>
                                            <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{formateDate(item?.partList?.requiredDate)}</td>
                                        </>
                                    }
                                    <td className={styles.previewtd} style={{ borderLeft: '1px solid #0000001A' }}>
                                        {isPending ?
                                            <input type="text" placeholder="Enter Date Code" className={styles.dataInput} value={quote.datecode || ''} onChange={(e) => setQuoteField(item?._id, 'datecode', e.target.value)} />
                                            :
                                            <input type="text" placeholder="Enter Date Code" className={styles.dataInput} value={item?.partList?.datecode ?? ''} disabled />
                                        }
                                    </td>
                                </tr>
                            )
                        })}
             
                    </tbody>
                </table>
              </div>
                {enquiryDetails?.status == "NEW" &&
                    <div className={styles.mainBtns}>
                        <button className={styles.quoteBtn}>Cancel</button>
                        <button className={styles.addBtn} onClick={handleSubmit}>Submit Quote</button>
                    </div>
                }
            </Paper>
        </div>
    )
}

export default VenEnquiryDeets



















// const VenEnquiryDeets = ({ enquiryDetails }) => {
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
    
//     const [quotes, setQuotes] = useState(
//         enquiryDetails?.partList?.map(() => ({ quotePrice: '', moq: '' }))
//     );

//     const handleInputChange = (index, field, value) => {
//         setQuotes(prev => {
//             const newQuotes = [...prev];
//             newQuotes[index][field] = value;
//             return newQuotes;
//         });
//     };

//     const handleSubmit = async () => {
//         if (quotes.some(q => !q.quotePrice || !q.moq)) {
//             return toast.error('All products must have quotePrice and moq values.');
//         }
//         if (quotes.some(q => isNaN(q.quotePrice) || isNaN(q.moq))) {
//             return toast.error('Please enter valid numbers for quotePrice and moq.');
//         }
        
//         const values = enquiryDetails.partList.map((item, index) => ({
//             ...item,
//             quotePrice: quotes[index].quotePrice,
//             moq: quotes[index].moq,
//         }));

//         const data = {
//             id: enquiryDetails?._id,
//             values,
//         };

//         try {
//             const response = await api.createQuote(data);
//             if (response.data) {
//                 toast.success('Quoted successfully');
//                 setQuotes(enquiryDetails?.partList?.map(() => ({ quotePrice: '', moq: '' })));
//                 dispatch(setReceiveEnquiryRefresh());
//             }
//         } catch (err) {
//             console.log(err);
//             toast.error(err?.response?.data?.message || 'Something went wrong');
//         }
//     };

//     return (
//         <table className={styles.previewtable}>
//             <tbody>
//                 {enquiryDetails?.partList?.map((item, index) => (
//                     <tr key={index} className={styles.previewstripedRow}>
//                         <td>{index + 1}</td>
//                         <td>{item?.productNumber}</td>
//                         <td>{item?.quantity}</td>
//                         <td>{item?.manufacturer}</td>
//                         <td>
//                             {enquiryDetails?.status === 'NEW' ? (
//                                 <input
//                                     type='text'
//                                     placeholder='Enter price'
//                                     className={styles.dataInput}
//                                     value={quotes[index]?.quotePrice}
//                                     onChange={(e) => handleInputChange(index, 'quotePrice', e.target.value)}
//                                 />
//                             ) : (
//                                 <input type='text' value={item?.quotePrice} disabled />
//                             )}
//                         </td>
//                         <td>
//                             {enquiryDetails?.status === 'NEW' ? (
//                                 <input
//                                     type='text'
//                                     placeholder='Enter MOQ'
//                                     className={styles.dataInput}
//                                     value={quotes[index]?.moq}
//                                     onChange={(e) => handleInputChange(index, 'moq', e.target.value)}
//                                 />
//                             ) : (
//                                 <input type='text' value={item?.moq} disabled />
//                             )}
//                         </td>
//                     </tr>
//                 ))}
//             </tbody>
//         </table>
//         {enquiryDetails?.status === 'NEW' && (
//             <div className={styles.mainBtns}>
//                 <button className={styles.quoteBtn}>Cancel</button>
//                 <button className={styles.addBtn} onClick={handleSubmit}>Submit Quote</button>
//             </div>
//         )}
//     );
// };

// export default VenEnquiryDeets;
